<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import Link from "svelte-link/src/Link.svelte";
    import { Form, FormGroup, Input, Col } from "sveltestrap";
    import bookmark from "../../Data/ComponentData/WidgetData/Genral/Bookmark.json";
    import {href} from "../../utils/Constant/Constant"
</script>

<Col sm="6">
    <div class="bookmark">
        <ul>
            {#each bookmark.Bookmark as Item}
                <li>
                    <Link href={Item.href}>
                        <FeatherIcon icon={Item.icon} />
                    </Link>
                </li>
            {/each}
            <li>
                <Link href={href}>
                    <FeatherIcon class="bookmark-search" icon="star" />
                </Link>
                <Form class="form-inline search-form">
                    <FormGroup class="form-group form-control-search">
                        <Input type="text" placeholder="Search.." />
                    </FormGroup>
                </Form>
            </li>
        </ul>
    </div>
</Col>
